<footer class="brand-info slide hide-for-print">
    <div class="row">
        <div class="small-4 medium columns hide-for-small">
            <a href="http://ucr.edu" class="logo-ucr hide-text"></a>
        </div>
        <div class="medium-8 large-8 columns">
            <span class="copyright hide-for-small-only">© {{currentYear}} Regents of the University of California </span>
            <span class="copyright show-for-small-only">© {{currentYear}} Regents of the UC </span>
        </div>
    </div>
</footer>
